/**
 * WalkthroughStyles.js
 *
 * Joyride style overrides. Passed to the `styles` prop of the Joyride component.
 * Configures the spotlight, overlay, and beacon to match the brand.
 *
 * Overlay is kept lighter/softer to avoid the "everything disappeared" feeling.
 * Spotlight ring uses a minimal single orange outline — no dual-ring glow.
 */

export const getWalkthroughStyles = (isDark) => ({
  options: {
    arrowColor: isDark ? '#0f1729' : '#ffffff',
    backgroundColor: isDark ? '#0f1729' : '#ffffff',
    // Keep overlay noticeably lighter — content should still feel present
    overlayColor: isDark ? 'rgba(4, 8, 20, 0.65)' : 'rgba(10, 20, 50, 0.3)',
    primaryColor: '#F87217',
    // Single, clean spotlight ring — no outer glow bloom
    spotlightShadow: '0 0 0 2px #F87217',
    textColor: isDark ? '#e8edf5' : '#1a2035',
    zIndex: 9999,
    width: 368,
  },
  // Spotlight box itself — rounded corners match card radius
  spotlight: {
    borderRadius: 10,
  },
  overlay: {
    mixBlendMode: 'normal',
  },
  // Beacons are disabled (disableBeacon: true on all steps) but style them anyway
  beaconInner: {
    backgroundColor: '#F87217',
  },
  beaconOuter: {
    backgroundColor: 'rgba(248,114,23,0.15)',
    border: '2px solid rgba(248,114,23,0.5)',
  },
  // ── Hide default UI (we render our own via tooltipComponent) ─────────────
  tooltip: {
    padding: 0,
    borderRadius: 0,
    boxShadow: 'none',
    filter: 'none',
    background: 'transparent',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    display: 'none',
  },
  tooltipContent: {
    padding: 0,
  },
  tooltipFooter: {
    display: 'none',
  },
  buttonNext: {
    display: 'none',
  },
  buttonBack: {
    display: 'none',
  },
  buttonSkip: {
    display: 'none',
  },
  buttonClose: {
    display: 'none',
  },
});